import React, {useEffect } from 'react';
import Header from "../Component/Header"; 
import { Link } from 'react-router-dom'
const BusRules = () => {
    useEffect(() => {
        document.title = 'Bus Rules -  The Air Force School Subroto Park';  
    }, []);  
  return (
     <>
       <Header/>
<div className="innerslide">
            <ul className="breadcrumb">
                <li><Link to="/"> Home</Link> </li> 
                <li> The Almanac  </li>
                 <li>School Rules</li>
                 <li>Bus Rules</li>
            </ul>
        </div> 
        <div className="innersec">
            <div className="container">
                <div className="row">
                    <div className="col-lg-12">
                        <h1> Bus Rules </h1>
                    </div>
                </div>
                <div className="row">
                    <div className="col-lg-12">
                    <ul className="list"> 
                    <li>  Arrive at  the  bus  stop  at  least  5  minutes before bus ETA (Expected Time of Arrival). </li>
                     <li> A student must carry the bus passes every day & hand over the same to conductor in the morning. </li>
                     <li> If a student has been picked up by parent, a written information must be given to HM and Bus I/c for accountability and to avoid any confusion. </li>
                     <li> If a student is unable to board the bus in the afternoon due to any reason, he/she must report immediately to the main office/HM office/any school official. Parents must educate/brief children in this regard. </li>
                     <li> Without proper bus passes, students will not be allowed to travel in the school bus. </li>
                     <li> Carry a written application by a parent, duly verified by the class teacher in case you need to travel on another route for a day. </li>
                     <li> Inform the bus driver/conductor in case you plan not to travel by the school bus on your return journey. </li>
                     <li> Parents   are   not   to   board   the   school buses/hired buses at any time for any reasons, whatsoever. </li>
                     <li> While in the bus students must Remain seated in the bus and do not extend any body part outside the window. </li>
                     <li> Wait  for  the  bus  to  come  to  a  halt  before boarding or deboarding. </li>
                     <li> Do not eat or drink in the bus. </li>
                     <li> Not   distract   the   driver's   attention   by shouting and other acts.</li>
                  </ul> 
                    </div>
                </div>
            </div>
        </div>
     </>
  )
}

export default BusRules